import { Box, Link, Typography, type SxProps, type Theme } from '@mui/material';

export const PACKBYTES_URL = 'https://packbytes.com/';

/**
 * "Powered by PackBytes" credit with the copyright line. The year comes from the clock, so it
 * moves to the next year on its own. `onDark` for the midnight sidebar.
 */
export function PoweredBy({ onDark = false, sx }: { onDark?: boolean; sx?: SxProps<Theme> }) {
  const muted = onDark ? 'rgba(224,231,255,0.6)' : 'text.secondary';
  return (
    <Box sx={sx}>
      <Typography variant="caption" component="p" align="center" sx={{ m: 0, color: muted }}>
        Powered by{' '}
        <Link
          href={PACKBYTES_URL}
          target="_blank"
          rel="noopener"
          underline="hover"
          sx={{ fontWeight: 700, color: onDark ? '#D7F5EC' : 'text.primary' }}
        >
          PackBytes
        </Link>
      </Typography>
      <Typography
        variant="caption"
        component="p"
        align="center"
        sx={{ m: 0, fontSize: '0.6875rem', color: muted }}
      >
        © {new Date().getFullYear()} PackBytes. All rights reserved.
      </Typography>
    </Box>
  );
}
